import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pb-16 relative overflow-x-auto rounded-md mt-4"
}
const _hoisted_2 = { class: "inline-block min-w-full pt-2 align-middle bg-white rounded-md" }
const _hoisted_3 = { class: "min-w-full divide-y divide-gray-300 rounded-md animate-pulse" }
const _hoisted_4 = { class: "divide-y divide-gray-200 bg-white rounded-md" }
const _hoisted_5 = {
  key: 0,
  class: "w-full flex items-center justify-center text-center mx-auto mt-8 my-4 text-gray-600"
}
const _hoisted_6 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_7 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_8 = {
  key: 2,
  class: "text-muted"
}
const _hoisted_9 = {
  key: 1,
  class: "inline-block min-w-full pt-2 align-middle bg-white rounded-md"
}
const _hoisted_10 = { class: "min-w-full divide-y divide-gray-300 rounded-md" }
const _hoisted_11 = {
  scope: "col",
  class: "px-3 py-3 text-left text-sm font-semibold text-gray-900"
}
const _hoisted_12 = {
  scope: "col",
  class: "px-3 py-3 text-left text-sm font-semibold text-gray-900"
}
const _hoisted_13 = {
  scope: "col",
  class: "px-3 py-3 text-left text-sm font-semibold text-gray-900"
}
const _hoisted_14 = {
  scope: "col",
  class: "px-3 py-3 text-left text-sm font-semibold text-gray-900"
}
const _hoisted_15 = ["onClick", "onContextmenu"]
const _hoisted_16 = { class: "py-3 pr-3 pl-4 text-sm whitespace-nowrap w-[1%] relative" }
const _hoisted_17 = {
  key: 0,
  class: "absolute inset-y-0 left-0 w-0.5 bg-black/50"
}
const _hoisted_18 = {
  key: 1,
  class: "absolute inset-y-0 left-0 w-0.5 bg-royal-blue-600"
}
const _hoisted_19 = { class: "size-11 shrink-0 relative" }
const _hoisted_20 = {
  key: 0,
  class: "size-11 rounded-full bg-gray-100 flex items-center justify-center text-gray-500"
}
const _hoisted_21 = ["poster"]
const _hoisted_22 = ["src"]
const _hoisted_23 = ["src", "alt"]
const _hoisted_24 = { class: "px-3 py-3 text-sm whitespace-nowrap text-gray-500" }
const _hoisted_25 = { class: "text-gray-900" }
const _hoisted_26 = {
  key: 0,
  class: "px-3 py-3 text-sm whitespace-nowrap text-gray-500",
  colspan: "2"
}
const _hoisted_27 = { class: "text-gray-900" }
const _hoisted_28 = {
  key: 1,
  class: "px-3 py-3 text-sm whitespace-nowrap text-gray-500"
}
const _hoisted_29 = { class: "text-gray-900" }
const _hoisted_30 = {
  key: 2,
  class: "px-3 py-3 text-sm whitespace-nowrap text-gray-500"
}
const _hoisted_31 = { class: "text-gray-900" }
const _hoisted_32 = {
  key: 3,
  class: "px-3 py-3 text-sm whitespace-nowrap text-gray-500"
}
const _hoisted_33 = { class: "flex items-center" }
const _hoisted_34 = {
  key: 4,
  class: "px-3 py-3 text-sm whitespace-nowrap text-gray-500"
}
const _hoisted_35 = { class: "text-gray-900" }
const _hoisted_36 = { class: "relative py-3 pr-4 pl-3 text-right text-sm font-medium whitespace-nowrap" }
const _hoisted_37 = { class: "flex gap-2 justify-end" }
const _hoisted_38 = ["onClick", "disabled"]
const _hoisted_39 = ["onClick", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PhotosListControlsComponent = _resolveComponent("PhotosListControlsComponent")!
  const _component_EyeSlashIcon = _resolveComponent("EyeSlashIcon")!
  const _component_StarIcon = _resolveComponent("StarIcon")!
  const _component_ArrowUturnLeftIcon = _resolveComponent("ArrowUturnLeftIcon")!
  const _component_TrashIcon = _resolveComponent("TrashIcon")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_DeletePhotosConfirmationModalComponent = _resolveComponent("DeletePhotosConfirmationModalComponent")!
  const _component_ContextMenuComponent = _resolveComponent("ContextMenuComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PhotosListControlsComponent, {
      folder: _ctx.folder,
      selected: _ctx.selected,
      onRemoveSelected: _ctx.removeSelected
    }, null, 8, ["folder", "selected", "onRemoveSelected"]),
    (_ctx.isLoadingPhotos)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("table", _hoisted_3, [
              _cache[10] || (_cache[10] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { class: "px-3 py-3" }, [
                    _createElementVNode("div", { class: "skeleton rounded h-4 w-4" })
                  ]),
                  _createElementVNode("th", { class: "px-3 py-3" }, [
                    _createElementVNode("div", { class: "skeleton rounded h-4 w-24" })
                  ]),
                  _createElementVNode("th", { class: "px-3 py-3" }, [
                    _createElementVNode("div", { class: "skeleton rounded h-4 w-16" })
                  ]),
                  _createElementVNode("th", { class: "px-3 py-3" }, [
                    _createElementVNode("div", { class: "skeleton rounded h-4 w-16" })
                  ]),
                  _createElementVNode("th", { class: "px-3 py-3" }, [
                    _createElementVNode("div", { class: "skeleton rounded h-4 w-20" })
                  ]),
                  _createElementVNode("th", { class: "relative py-3 pr-4 pl-3" }, [
                    _createElementVNode("div", { class: "skeleton rounded h-4 w-8 ml-auto" })
                  ])
                ])
              ], -1)),
              _createElementVNode("tbody", _hoisted_4, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (i) => {
                  return _createElementVNode("tr", {
                    class: "cursor-default",
                    key: `skeleton-row-${i}`
                  }, _cache[9] || (_cache[9] = [
                    _createElementVNode("td", { class: "px-3 py-3" }, [
                      _createElementVNode("div", { class: "skeleton rounded-full w-10 h-10" })
                    ], -1),
                    _createElementVNode("td", { class: "px-3 py-3" }, [
                      _createElementVNode("div", { class: "skeleton rounded h-4 w-24" })
                    ], -1),
                    _createElementVNode("td", { class: "px-3 py-3" }, [
                      _createElementVNode("div", { class: "skeleton rounded h-4 w-16" })
                    ], -1),
                    _createElementVNode("td", { class: "px-3 py-3" }, [
                      _createElementVNode("div", { class: "skeleton rounded h-4 w-16" })
                    ], -1),
                    _createElementVNode("td", { class: "px-3 py-3" }, [
                      _createElementVNode("div", { class: "skeleton rounded h-4 w-20" })
                    ], -1),
                    _createElementVNode("td", { class: "relative py-3 pr-4 pl-3 text-right" }, [
                      _createElementVNode("div", { class: "skeleton rounded h-6 w-20 ml-auto" })
                    ], -1)
                  ]))
                }), 64))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isLoadingPhotos)
      ? (_openBlock(), _createElementBlock("section", {
          key: 1,
          class: _normalizeClass({'pb-16 relative overflow-x-auto rounded-md': true, 'mt-4': _ctx.selected.length === 0}),
          ref: "photosContainer"
        }, [
          (_ctx.photos.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (!_ctx.isTrashedFolder && _ctx.folder)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                      _createTextVNode(_toDisplayString(_ctx.$t('files.empty.folders_1')) + " ", 1),
                      _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                      _createTextVNode(_toDisplayString(_ctx.$t('files.empty.folders_2')), 1)
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.folder && !_ctx.isTrashedFolder)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('files.empty.files')), 1))
                  : _createCommentVNode("", true),
                (_ctx.isTrashedFolder)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('files.empty.trashed')), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.photos.length !== 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("table", _hoisted_10, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _cache[12] || (_cache[12] = _createElementVNode("th", {
                        scope: "col",
                        class: "px-3 py-3 text-left text-sm font-semibold text-gray-900"
                      }, null, -1)),
                      _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('files.list.name')), 1),
                      _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('files.list.type')), 1),
                      _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('files.list.size')), 1),
                      _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.isTrashedFolder ? _ctx.$t('files.list.deleted') : _ctx.$t('files.list.folders')), 1),
                      _cache[13] || (_cache[13] = _createElementVNode("th", {
                        scope: "col",
                        class: "relative py-3 pr-4 pl-3 sm:pr-0"
                      }, null, -1))
                    ])
                  ]),
                  _createVNode(_component_draggable, {
                    modelValue: _ctx.sortedPhotos,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.sortedPhotos) = $event)),
                    onStart: _cache[4] || (_cache[4] = ($event: any) => (_ctx.drag=true)),
                    onEnd: _cache[5] || (_cache[5] = ($event: any) => (_ctx.drag=false)),
                    "item-key": "id",
                    tag: "tbody",
                    role: "list",
                    class: _normalizeClass({'divide-y divide-gray-200 bg-white rounded-md': true}),
                    disabled: _ctx.isSelecting
                  }, {
                    item: _withCtx(({element, index}) => [
                      _createElementVNode("tr", {
                        onClick: _withModifiers(($event: any) => (_ctx.select(element, index, $event)), ["prevent"]),
                        onContextmenu: _withModifiers(($event: any) => (_ctx.showContextMenuForPhoto(element, $event)), ["prevent"]),
                        onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onVideoMouseEnter($event))),
                        onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onVideoMouseLeave($event))),
                        class: _normalizeClass({
                                'photo-list-item rounded-md cursor-pointer': true,
                                'bg-royal-blue-50': _ctx.isSelectedPhoto(element),
                                'hover:bg-gray-100': !_ctx.isSelectedPhoto(element),
                                'bg-gray-50': element.is_compressing,
                            }),
                        ref: `photo-${index}`
                      }, [
                        _createElementVNode("td", _hoisted_16, [
                          (element.is_compressing)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17))
                            : _createCommentVNode("", true),
                          (_ctx.isSelectedPhoto(element))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_19, [
                            (element.is_compressing)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, _cache[14] || (_cache[14] = [
                                  _createElementVNode("svg", {
                                    class: "w-5 h-5 animate-spin",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    fill: "none",
                                    viewBox: "0 0 24 24"
                                  }, [
                                    _createElementVNode("circle", {
                                      class: "opacity-25",
                                      cx: "12",
                                      cy: "12",
                                      r: "10",
                                      stroke: "currentColor",
                                      "stroke-width": "4"
                                    }),
                                    _createElementVNode("path", {
                                      class: "opacity-75",
                                      fill: "currentColor",
                                      d: "M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                                    })
                                  ], -1)
                                ])))
                              : _createCommentVNode("", true),
                            (!element.is_compressing && element.is_video && element.compressed_video_url)
                              ? (_openBlock(), _createElementBlock("video", {
                                  key: 1,
                                  class: "size-11 rounded-full object-cover",
                                  preload: "metadata",
                                  playsinline: "",
                                  muted: "",
                                  poster: element.preview_mini_url,
                                  loop: ""
                                }, [
                                  _createElementVNode("source", {
                                    src: element.compressed_video_url,
                                    type: "video/mp4"
                                  }, null, 8, _hoisted_22),
                                  _cache[15] || (_cache[15] = _createTextVNode(" Your browser does not support the video tag. "))
                                ], 8, _hoisted_21))
                              : _createCommentVNode("", true),
                            (!element.is_compressing && (!element.is_video || element.compressed_video_url === null))
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 2,
                                  class: "size-11 rounded-full object-cover",
                                  src: element.preview_mini_url,
                                  alt: element.original_filename,
                                  onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleImageError && _ctx.handleImageError(...args)))
                                }, null, 40, _hoisted_23))
                              : _createCommentVNode("", true),
                            (element.is_hidden_by_client)
                              ? (_openBlock(), _createBlock(_component_EyeSlashIcon, {
                                  key: 3,
                                  class: "absolute -top-1 -right-1 text-white bg-gray-600 p-0.5 rounded-full size-5"
                                }))
                              : _createCommentVNode("", true),
                            (element.is_cover)
                              ? (_openBlock(), _createBlock(_component_StarIcon, {
                                  key: 4,
                                  class: "absolute -top-1 -left-1 text-white bg-gray-600 p-0.5 rounded-full size-5"
                                }))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, _toDisplayString(element.original_filename), 1)
                        ]),
                        (element.is_compressing)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_26, [
                              _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('files.file_is_compressing')), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (!element.is_compressing)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_28, [
                              _createElementVNode("div", _hoisted_29, _toDisplayString(element.is_video ? _ctx.$t('files.types.video') : _ctx.$t('files.types.photo')), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (!element.is_compressing)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_30, [
                              _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.formatStorage(element.filesize, _ctx.$t)), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (!_ctx.isTrashedFolder)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_32, [
                              _createElementVNode("div", _hoisted_33, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.folders, (_folder, folderIndex) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: `folder-photo-label-${element.id}-${_folder.id}-${folderIndex}`,
                                    class: "ml-1"
                                  }, [
                                    (_openBlock(), _createElementBlock("svg", {
                                      class: "size-1.5",
                                      style: _normalizeStyle(`fill: ${_folder.color}` as any),
                                      viewBox: "0 0 6 6",
                                      "aria-hidden": "true"
                                    }, _cache[16] || (_cache[16] = [
                                      _createElementVNode("circle", {
                                        cx: "3",
                                        cy: "3",
                                        r: "3"
                                      }, null, -1)
                                    ]), 4))
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isTrashedFolder)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_34, [
                              _createElementVNode("div", _hoisted_35, _toDisplayString(element.deleted_at), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("td", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, [
                            (_ctx.isTrashedFolder)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  onClick: _withModifiers(($event: any) => (_ctx.recoverItem(element)), ["prevent"]),
                                  disabled: _ctx.isRecoveringDeletedItem,
                                  type: "button",
                                  class: "text-xs font-normal text-white bg-royal-blue-500 p-1.5 rounded-full hover:bg-royal-blue-600 focus:outline-none cursor-pointer flex items-center gap-1"
                                }, [
                                  _createVNode(_component_ArrowUturnLeftIcon, { class: "size-4" })
                                ], 8, _hoisted_38))
                              : _createCommentVNode("", true),
                            _createElementVNode("button", {
                              onClick: _withModifiers(($event: any) => (_ctx.deleteItem(element)), ["prevent"]),
                              disabled: _ctx.isDeletingPhoto,
                              type: "button",
                              class: "text-xs font-normal text-white bg-red-600 px-2 py-1.5 rounded-full hover:bg-red-700 focus:outline-none cursor-pointer flex items-center gap-1"
                            }, [
                              _createVNode(_component_TrashIcon, { class: "size-4" }),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('files.delete_button')), 1)
                            ], 8, _hoisted_39)
                          ])
                        ])
                      ], 42, _hoisted_15)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isSelecting)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "selection-box",
                style: _normalizeStyle(_ctx.selectionBoxStyle)
              }, null, 4))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    _createVNode(_component_DeletePhotosConfirmationModalComponent, {
      open: _ctx.isDeletingConfirmation !== null,
      onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isDeletingConfirmation = null)),
      onConfirmAction: _cache[7] || (_cache[7] = ($event: any) => (_ctx.deleteItem(_ctx.isDeletingConfirmation))),
      title: _ctx.$t('files.delete_confirmation_title'),
      message: _ctx.isTrashedFolder ? _ctx.$t('files.delete_confirmation_message') : _ctx.$t('files.delete_confirmation_trash'),
      buttonText: _ctx.$t('files.delete_confirmation_button'),
      isLoading: _ctx.isDeletingPhoto
    }, null, 8, ["open", "title", "message", "buttonText", "isLoading"]),
    _createVNode(_component_ContextMenuComponent, {
      photo: _ctx.contextMenuPhoto,
      folders: _ctx.allFolders,
      "is-visible": _ctx.showContextMenu,
      position: _ctx.contextMenuPosition,
      "is-trashed-folder": _ctx.isTrashedFolder,
      onClose: _ctx.closeContextMenu,
      onDelete: _ctx.handleContextDelete,
      onRecover: _ctx.handleContextRecover,
      onAddToScene: _ctx.handleAddToScene,
      onMakeCover: _ctx.handleMakeCover,
      onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
    }, null, 8, ["photo", "folders", "is-visible", "position", "is-trashed-folder", "onClose", "onDelete", "onRecover", "onAddToScene", "onMakeCover"])
  ], 64))
}